var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"htmlRoot",style:({ fontFamily: _vm.reportFontFamily }),attrs:{"id":"v-html-text"}},[_c('div',{directives:[{name:"image-modal",rawName:"v-image-modal",value:(_vm.enableImageModal),expression:"enableImageModal"}],staticClass:"bc-simple-content bc-simple-content-sb",domProps:{"innerHTML":_vm._s(_vm.sanitizedContent)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }